export const LOCAL_STORAGE_ROOKIE_SCORE_REF = 'rookieScoreRef'
